import React from "react";
import {
  FormCreationData,
  DeviceType,
} from "../../../../../stateManager/store/formCreation_v2/types";
import { Grid } from "./Grid";
import { Flex } from "./Flex";
// import "./CustomModal.css"

interface ICustomModal {
  isCoreV3: boolean;
  element: FormCreationData;
  deviceType: DeviceType;
  isCheckedIn: Boolean;
}

export const CustomModal: React.FC<ICustomModal> = (props) => {
  const { element, deviceType, isCheckedIn, isCoreV3 } = props;
  const { properties, fields } = element;
  const { modalOverlay, borderRadius, boxShadow = {
    x: "",
    y: "",
    blur: "",
    spread: "",
    color: ""
  },
  fontFamily='Inherit'
  } = properties.styles.common;
  const styles = properties.styles[deviceType];
  const { width, widthMode, height, heightMode } = styles;
  const isContainerEmpty = fields && fields.length === 0;

  const modalStyle: React.CSSProperties = {
    zIndex: 1001,
    backgroundColor: modalOverlay,
    fontFamily:fontFamily
  };

  const modalContentStyle: React.CSSProperties = {
    width: width ? width === "auto" ? width
      : width === "min-content" ? width
        : width === "max-content" ? width
          : `${width}${widthMode}`
      : "auto",
    height: height ? height === "auto" ? height
      : height === "min-content" ? height
        : height === "max-content" ? height
          : `${height}${heightMode}`
      : "auto",
    borderRadius: borderRadius ? `${borderRadius}px` : 0,
    boxShadow: `${boxShadow.y}px ${boxShadow.x}px ${boxShadow.blur}px ${boxShadow.spread}px ${boxShadow.color}`
  };

  if (isContainerEmpty && !height) {
    modalContentStyle.height = 135;
  }

  const modalStyleV3: React.CSSProperties = {
    zIndex: 1001,
    backgroundColor: modalOverlay,
    fontFamily:fontFamily,
  };

  const modalContentStyleV3: React.CSSProperties = {
    width: width ? width === "auto" ? width
      : width === "min-content" ? width
        : width === "max-content" ? width
          : `${width}${widthMode}`
      : "auto",
    height: height ? 
      height === "auto" ? height : `${height}${heightMode}`
      : "",
    maxHeight: "100%",
    overflow: "auto",
    ...( borderRadius ? {borderRadius: `${borderRadius}px`} : {}),
    boxShadow: `${boxShadow.y}px ${boxShadow.x}px ${boxShadow.blur}px ${boxShadow.spread}px ${boxShadow.color}`,
  };

  if (!width) {
    if (deviceType === "Sm") {
      modalContentStyleV3.width = '300px';
    }
    else if (deviceType === "Md") {
      modalContentStyleV3.width = '600px';
    }
    else if (deviceType === "Lg") {
      modalContentStyleV3.width = '1000px';
    }
  }

  let combinedClassName = properties?.config?.classNameTags?.join(" ") || [];
  
  return (
    <>
      {isCoreV3 ?
        <div
          id={`a8modal_${element.id}`}
          style={modalStyleV3}
          className="custom-modal-component fixed left-0 top-0 w-full h-full flex justify-center items-center"
        >
          <div className={`${combinedClassName} custom-modal-component__inner`} style={modalContentStyleV3}>
            <Flex
              minHeight={624}
              element={element}
              deviceType={deviceType}
              isCheckedIn={isCheckedIn}
            />
          </div>
        </div>
        :
        <div
          id={`a8modal_${element.id}`}
          style={modalStyle}
          className="fixed left-0 top-0 w-full h-full flex justify-center items-center"
        >
          <div style={modalContentStyle}>
            <Grid
              element={element}
              deviceType={deviceType}
              isCheckedIn={isCheckedIn}
            />
          </div>
        </div>
      }
    </>
  );
};
